import { useState } from "react";

const useCountryTooltip = (initialProps = {}) => {
  const [stateCountryTooltip, setState] = useState({
    visible: false,
    position: { x: 0, y: 0 },
  });

  const setCountryTooltip = (field, value) => {
    if (typeof field === "object") {
      setState((prevState) => ({ ...prevState, ...field }));
    } else {
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const toggleCountryTooltipField = (field) => {
    setState((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  return {
    stateCountryTooltip,
    setCountryTooltip,
    toggleCountryTooltipField,
  };
};

export default useCountryTooltip;
